var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFinancing = function SvgIconFinancing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#294C89",
    cx: 12,
    cy: 12,
    r: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.462 14.143c.563 0 1.047-.1 1.326-.172a.287.287 0 0 0 .205-.34l-.15-.703a.278.278 0 0 0-.334-.218c-.237.058-.611.13-1.03.13-1.512 0-2.7-.945-3.188-2.33h2.986a.277.277 0 0 0 .27-.23l.116-.574c.034-.179-.095-.344-.27-.344H9.979a6.373 6.373 0 0 1-.014-1.148h3.748a.277.277 0 0 0 .27-.227l.118-.574a.284.284 0 0 0-.27-.347h-3.623c.484-1.397 1.672-2.344 3.229-2.344.339 0 .666.05.88.091a.276.276 0 0 0 .319-.208l.182-.708a.287.287 0 0 0-.217-.356 6.197 6.197 0 0 0-1.137-.112c-2.306 0-4.144 1.533-4.749 3.635h-.724a.283.283 0 0 0-.277.287v.574c0 .158.125.287.277.287h.533c-.028.378-.023.849.01 1.148H7.99a.283.283 0 0 0-.277.287v.574c0 .157.125.287.277.287h.743c.6 2.121 2.385 3.635 4.728 3.635zM14.635 20.234c.304 0 .744-.154.981-.344l3.714-2.97a.89.89 0 0 0 .294-.614.896.896 0 0 0-.263-.587c-.29-.263-.742-.246-1.046 0l-2.269 1.814c-.236.19-.675.344-.978.344H12.16a.393.393 0 0 1 0-.786h1.922c.39 0 .754-.267.817-.653a.924.924 0 0 0 .011-.13v-.004a.786.786 0 0 0-.786-.784h-3.928c-.566 0-1.38.29-1.82.645l-1.141.926H2.557a.393.393 0 0 0-.392.393l1.017 2.357c0 .4.605.393.822.393h10.631z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};
export default SvgIconFinancing;